import { z } from 'zod';

export const rawIssueSLAsSchema = z.object({
  sla_due_days: z.number(),
});
export type RawIssueSLAsSchema = z.infer<typeof rawIssueSLAsSchema>;

export const issueSLAsSchema = rawIssueSLAsSchema.transform((data) => ({
  slaDueDays: data.sla_due_days,
}));

export type IssueSLAsEntity = z.infer<typeof issueSLAsSchema>;
